import { getInitials } from '@demand-iq/core';
import { ChevronDown } from 'lucide-react';
import { useUserInfo } from 'pages/UserProvider';
import AccountMenuItems from '@/components/shared/AccountMenuItems';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar';

const CompanyNavMenu = (): JSX.Element => {
  const { user, company } = useUserInfo();
  const { isMobile } = useSidebar();

  const companyName = company?.companyName ?? '';
  const userName = user?.userProfile?.name ?? user?.username ?? '';
  const rawLogo = company?.logo ?? '';
  const companyLogo =
    rawLogo && !rawLogo.startsWith('data:') && !rawLogo.startsWith('http')
      ? `data:image/png;base64,${rawLogo}`
      : rawLogo;

  return (
    <SidebarMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton
            size="lg"
            className="rounded-lg data-[state=open]:bg-sidebar-primary data-[state=open]:text-sidebar-primary-foreground"
            data-testid="company-nav-trigger"
          >
            <Avatar className="size-8 rounded-lg">
              {companyLogo && <AvatarImage src={companyLogo} alt={companyName} />}
              <AvatarFallback className="rounded-lg text-xs">
                {companyName ? getInitials(companyName) : 'DQ'}
              </AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-medium">{companyName}</span>
              <span className="truncate text-xs text-sidebar-foreground/50">{userName}</span>
            </div>
            <ChevronDown className="ml-auto size-4" />
          </SidebarMenuButton>
        </DropdownMenuTrigger>

        <DropdownMenuContent
          className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
          side={isMobile ? 'bottom' : 'right'}
          align="end"
          sideOffset={4}
        >
          <AccountMenuItems />
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  );
};

export default CompanyNavMenu;
